//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_IMAGE_CLASSIFICATION_BASE_URL = new InjectionToken<string>('API_IMAGE_CLASSIFICATION_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class BottleCapsICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_IMAGE_CLASSIFICATION_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-image-classification";
    }

    /**
     * Gets all the bottle caps starting with the given prefix. Max 100 items.
     * @param prefix (optional) 
     * @return Success
     */
    searchBottleCaps(prefix: string | null | undefined): Observable<BottleCap[]> {
        let url_ = this.baseUrl + "/api/bottle-caps?";
        if (prefix !== undefined && prefix !== null)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBottleCaps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBottleCaps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BottleCap[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BottleCap[]>;
        }));
    }

    protected processSearchBottleCaps(response: HttpResponseBase): Observable<BottleCap[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BottleCap.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a bottle cap - if id is not found, an error will be thrown.
     * @param id (optional) 
     * @return Success
     */
    deleteBottleCap(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/bottle-caps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBottleCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBottleCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBottleCap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets bottle cap information by id
     * @return Success
     */
    getBottleCapById(id: string): Observable<BottleCap> {
        let url_ = this.baseUrl + "/api/bottle-caps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBottleCapById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBottleCapById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BottleCap>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BottleCap>;
        }));
    }

    protected processGetBottleCapById(response: HttpResponseBase): Observable<BottleCap> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BottleCap.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the bottle cap identified by the given id
     * @param bottleCap (optional) 
     * @return Success
     */
    createOrUpdateBottleCap(id: string, bottleCap: BottleCapPutRequest | null | undefined): Observable<BottleCap> {
        let url_ = this.baseUrl + "/api/bottle-caps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bottleCap);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateBottleCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateBottleCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BottleCap>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BottleCap>;
        }));
    }

    protected processCreateOrUpdateBottleCap(response: HttpResponseBase): Observable<BottleCap> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BottleCap.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new bottle cap - if an existing bottle cap with the same id already exists, an error will be thrown.
     * @param bottleCap (optional) 
     * @return Success
     */
    createBottleCap(id: string, bottleCap: BottleCapPutRequest | null | undefined): Observable<BottleCap> {
        let url_ = this.baseUrl + "/api/bottle-caps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bottleCap);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBottleCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBottleCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BottleCap>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BottleCap>;
        }));
    }

    protected processCreateBottleCap(response: HttpResponseBase): Observable<BottleCap> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BottleCap.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BottleProductAppICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_IMAGE_CLASSIFICATION_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-image-classification";
    }

    /**
     * Gets bottle product information by ids
     * @param ids (optional) 
     * @return Success
     */
    getBottleProductByIds(ids: string[] | null | undefined): Observable<BottleProduct[]> {
        let url_ = this.baseUrl + "/api/app/bottle-product/ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBottleProductByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBottleProductByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BottleProduct[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BottleProduct[]>;
        }));
    }

    protected processGetBottleProductByIds(response: HttpResponseBase): Observable<BottleProduct[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BottleProduct.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BottleProductsICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_IMAGE_CLASSIFICATION_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-image-classification";
    }

    /**
     * Gets all the bottle products. Max 10000 items.
     * @return Success
     */
    getAllBottleProducts(): Observable<BottleProduct[]> {
        let url_ = this.baseUrl + "/api/bottle-products";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBottleProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBottleProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BottleProduct[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BottleProduct[]>;
        }));
    }

    protected processGetAllBottleProducts(response: HttpResponseBase): Observable<BottleProduct[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BottleProduct.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets bottle product information by id
     * @return Success
     */
    getBottleProductById(id: string): Observable<BottleProduct> {
        let url_ = this.baseUrl + "/api/bottle-products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBottleProductById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBottleProductById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BottleProduct>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BottleProduct>;
        }));
    }

    protected processGetBottleProductById(response: HttpResponseBase): Observable<BottleProduct> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BottleProduct.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the bottle product identified by the given id
     * @param bottleProduct (optional) 
     * @return Success
     */
    createOrUpdateBottleProduct(id: string, bottleProduct: BottleProduct | null | undefined): Observable<BottleProduct> {
        let url_ = this.baseUrl + "/api/bottle-products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bottleProduct);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateBottleProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateBottleProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BottleProduct>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BottleProduct>;
        }));
    }

    protected processCreateOrUpdateBottleProduct(response: HttpResponseBase): Observable<BottleProduct> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BottleProduct.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a bottle product - if id is not found, an error will be thrown.
     * @return Success
     */
    deleteBottleProduct(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/bottle-products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBottleProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBottleProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBottleProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClassifierInfoICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_IMAGE_CLASSIFICATION_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-image-classification";
    }

    /**
     * @return Success
     */
    getClassifierInfo(): Observable<string> {
        let url_ = this.baseUrl + "/api/classifier-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClassifierInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClassifierInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetClassifierInfo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClassifierModelsICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_IMAGE_CLASSIFICATION_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-image-classification";
    }

    /**
     * Returns all classifier models
     * @return Success
     */
    getAllClassifierModels(): Observable<ClassifierModel[]> {
        let url_ = this.baseUrl + "/api/classifier-models";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClassifierModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClassifierModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClassifierModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClassifierModel[]>;
        }));
    }

    protected processGetAllClassifierModels(response: HttpResponseBase): Observable<ClassifierModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassifierModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns all classifier models
     * @return Success
     */
    getAllClassifierModelsWithDetails(): Observable<ClassifierModelWithDetails[]> {
        let url_ = this.baseUrl + "/api/classifier-models/allWithDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClassifierModelsWithDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClassifierModelsWithDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClassifierModelWithDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClassifierModelWithDetails[]>;
        }));
    }

    protected processGetAllClassifierModelsWithDetails(response: HttpResponseBase): Observable<ClassifierModelWithDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassifierModelWithDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns all classifier models from the given training set
     * @return Success
     */
    getClassifierModelsByTrainingSetId(trainingSetId: string): Observable<ClassifierModel[]> {
        let url_ = this.baseUrl + "/training-set/{trainingSetId}";
        if (trainingSetId === undefined || trainingSetId === null)
            throw new Error("The parameter 'trainingSetId' must be defined.");
        url_ = url_.replace("{trainingSetId}", encodeURIComponent("" + trainingSetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClassifierModelsByTrainingSetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClassifierModelsByTrainingSetId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClassifierModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClassifierModel[]>;
        }));
    }

    protected processGetClassifierModelsByTrainingSetId(response: HttpResponseBase): Observable<ClassifierModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassifierModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the model with the provided id and the associated resources
     * @return Success
     */
    deleteClassifierModel(id: string): Observable<RefId[]> {
        let url_ = this.baseUrl + "/api/classifier-models/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClassifierModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClassifierModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefId[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefId[]>;
        }));
    }

    protected processDeleteClassifierModel(response: HttpResponseBase): Observable<RefId[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefId.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getClassifierModelById(id: string): Observable<ClassifierModelWithDetails> {
        let url_ = this.baseUrl + "/api/classifier-models/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClassifierModelById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClassifierModelById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClassifierModelWithDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClassifierModelWithDetails>;
        }));
    }

    protected processGetClassifierModelById(response: HttpResponseBase): Observable<ClassifierModelWithDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassifierModelWithDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deployModel(modelId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/classifier-models/{modelId}/deploy";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeployModel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trainingDetails (optional) 
     * @return Success
     */
    startTraining(trainingSetId: string, trainingDetails: TrainingDetails | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/classifier-models/startTraining/{trainingSetId}";
        if (trainingSetId === undefined || trainingSetId === null)
            throw new Error("The parameter 'trainingSetId' must be defined.");
        url_ = url_.replace("{trainingSetId}", encodeURIComponent("" + trainingSetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trainingDetails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartTraining(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartTraining(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartTraining(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTraininingResult(executionName: string): Observable<ClassifierModelStateMachineExecutionResult> {
        let url_ = this.baseUrl + "/api/classifier-models/getTrainingResult/{executionName}";
        if (executionName === undefined || executionName === null)
            throw new Error("The parameter 'executionName' must be defined.");
        url_ = url_.replace("{executionName}", encodeURIComponent("" + executionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTraininingResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTraininingResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClassifierModelStateMachineExecutionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClassifierModelStateMachineExecutionResult>;
        }));
    }

    protected processGetTraininingResult(response: HttpResponseBase): Observable<ClassifierModelStateMachineExecutionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassifierModelStateMachineExecutionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param classifierModel (optional) 
     * @return Success
     */
    updateClassifierModel(modelId: string, classifierModel: ClassifierModel | null | undefined): Observable<ClassifierModel> {
        let url_ = this.baseUrl + "/api/classifier-models/{modelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(classifierModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClassifierModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClassifierModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClassifierModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClassifierModel>;
        }));
    }

    protected processUpdateClassifierModel(response: HttpResponseBase): Observable<ClassifierModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassifierModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reference (optional) 
     * @return Success
     */
    addClassifierModelReference(modelId: string, reference: RefId | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/classifier-models/{modelId}/reference";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reference);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddClassifierModelReference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddClassifierModelReference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddClassifierModelReference(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reference (optional) 
     * @return Success
     */
    deleteClassifierModelReference(modelId: string, reference: RefId | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/classifier-models/{modelId}/reference";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reference);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClassifierModelReference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClassifierModelReference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteClassifierModelReference(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PredictICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_IMAGE_CLASSIFICATION_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-image-classification";
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    predict(request: PredictionRequest | null | undefined): Observable<PredictionResponse> {
        let url_ = this.baseUrl + "/api/Predict/predict";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPredict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPredict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredictionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredictionResponse>;
        }));
    }

    protected processPredict(response: HttpResponseBase): Observable<PredictionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PredictionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TrainingSetsICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_IMAGE_CLASSIFICATION_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-image-classification";
    }

    /**
     * Gets all the training sets starting with the given prefix
     * @return Success
     */
    getAllTrainingSets(): Observable<TrainingSet[]> {
        let url_ = this.baseUrl + "/api/training-sets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrainingSets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrainingSets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingSet[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingSet[]>;
        }));
    }

    protected processGetAllTrainingSets(response: HttpResponseBase): Observable<TrainingSet[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingSet.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new training set
     * @param trainingSet (optional) 
     * @return Success
     */
    createTrainingSet(trainingSet: TrainingSet | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/training-sets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trainingSet);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTrainingSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTrainingSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTrainingSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates (or creates) a training set
     * @param trainingSetId (optional) 
     * @param trainingSet (optional) 
     * @return Success
     */
    createOrUpdateTrainingSet(trainingSetId: string | null | undefined, trainingSet: TrainingSet | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/training-sets?";
        if (trainingSetId !== undefined && trainingSetId !== null)
            url_ += "trainingSetId=" + encodeURIComponent("" + trainingSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trainingSet);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateTrainingSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateTrainingSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateTrainingSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the training set starting with the given trainingSetId
     * @return Success
     */
    getTrainingSetById(trainingSetId: string): Observable<TrainingSet> {
        let url_ = this.baseUrl + "/api/training-sets/{trainingSetId}";
        if (trainingSetId === undefined || trainingSetId === null)
            throw new Error("The parameter 'trainingSetId' must be defined.");
        url_ = url_.replace("{trainingSetId}", encodeURIComponent("" + trainingSetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingSetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingSetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingSet>;
        }));
    }

    protected processGetTrainingSetById(response: HttpResponseBase): Observable<TrainingSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a whole training set
     * @return Success
     */
    deleteTrainingSet(trainingSetId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/training-sets/{trainingSetId}";
        if (trainingSetId === undefined || trainingSetId === null)
            throw new Error("The parameter 'trainingSetId' must be defined.");
        url_ = url_.replace("{trainingSetId}", encodeURIComponent("" + trainingSetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrainingSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrainingSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTrainingSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the image set of the bottleCapId in the provided trainingSetId
     * @return Success
     */
    getImageSet(trainingSetId: string, bottleCapId: string): Observable<ImageSet> {
        let url_ = this.baseUrl + "/api/training-sets/{trainingSetId}/{bottleCapId}";
        if (trainingSetId === undefined || trainingSetId === null)
            throw new Error("The parameter 'trainingSetId' must be defined.");
        url_ = url_.replace("{trainingSetId}", encodeURIComponent("" + trainingSetId));
        if (bottleCapId === undefined || bottleCapId === null)
            throw new Error("The parameter 'bottleCapId' must be defined.");
        url_ = url_.replace("{bottleCapId}", encodeURIComponent("" + bottleCapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImageSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImageSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageSet>;
        }));
    }

    protected processGetImageSet(response: HttpResponseBase): Observable<ImageSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds an image to an image set
     * @param image (optional) 
     * @return Success
     */
    addImageToSet(trainingSetId: string, bottleCapId: string, image: ImageUrl | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/training-sets/{trainingSetId}/{bottleCapId}";
        if (trainingSetId === undefined || trainingSetId === null)
            throw new Error("The parameter 'trainingSetId' must be defined.");
        url_ = url_.replace("{trainingSetId}", encodeURIComponent("" + trainingSetId));
        if (bottleCapId === undefined || bottleCapId === null)
            throw new Error("The parameter 'bottleCapId' must be defined.");
        url_ = url_.replace("{bottleCapId}", encodeURIComponent("" + bottleCapId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(image);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddImageToSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddImageToSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddImageToSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the image set of the bottleCapId in the provided trainingSetId
     * @return Success
     */
    getProcessedImageSet(trainingSetId: string, bottleCapId: string): Observable<ImageSet> {
        let url_ = this.baseUrl + "/api/training-sets/{trainingSetId}/{bottleCapId}/processed";
        if (trainingSetId === undefined || trainingSetId === null)
            throw new Error("The parameter 'trainingSetId' must be defined.");
        url_ = url_.replace("{trainingSetId}", encodeURIComponent("" + trainingSetId));
        if (bottleCapId === undefined || bottleCapId === null)
            throw new Error("The parameter 'bottleCapId' must be defined.");
        url_ = url_.replace("{bottleCapId}", encodeURIComponent("" + bottleCapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessedImageSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessedImageSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageSet>;
        }));
    }

    protected processGetProcessedImageSet(response: HttpResponseBase): Observable<ImageSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the list of ids from the bottle cap set
     * @param url (optional) 
     * @return Success
     */
    deleteImageFromSet(trainingSetId: string, bottleCap: string, url: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/training-sets/{trainingSetId}/{bottleCap}?";
        if (trainingSetId === undefined || trainingSetId === null)
            throw new Error("The parameter 'trainingSetId' must be defined.");
        url_ = url_.replace("{trainingSetId}", encodeURIComponent("" + trainingSetId));
        if (bottleCap === undefined || bottleCap === null)
            throw new Error("The parameter 'bottleCap' must be defined.");
        url_ = url_.replace("{bottleCap}", encodeURIComponent("" + bottleCap));
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImageFromSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImageFromSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteImageFromSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads an image to an imageset and returns the S3 url
     * @param file (optional) 
     * @return Success
     */
    uploadImageToSet(trainingSetId: string, bottleCapId: string, file: FileToUpload | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/training-sets/UploadImageToSet/{trainingSetId}/{bottleCapId}";
        if (trainingSetId === undefined || trainingSetId === null)
            throw new Error("The parameter 'trainingSetId' must be defined.");
        url_ = url_.replace("{trainingSetId}", encodeURIComponent("" + trainingSetId));
        if (bottleCapId === undefined || bottleCapId === null)
            throw new Error("The parameter 'bottleCapId' must be defined.");
        url_ = url_.replace("{bottleCapId}", encodeURIComponent("" + bottleCapId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImageToSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImageToSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadImageToSet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param newTrainingSetName (optional) 
     * @return Success
     */
    cloneTrainingSet(sourceTrainingSetId: string, newTrainingSetName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/training-sets/{sourceTrainingSetId}/clone?";
        if (sourceTrainingSetId === undefined || sourceTrainingSetId === null)
            throw new Error("The parameter 'sourceTrainingSetId' must be defined.");
        url_ = url_.replace("{sourceTrainingSetId}", encodeURIComponent("" + sourceTrainingSetId));
        if (newTrainingSetName !== undefined && newTrainingSetName !== null)
            url_ += "newTrainingSetName=" + encodeURIComponent("" + newTrainingSetName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneTrainingSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneTrainingSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCloneTrainingSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param newTrainingSetName (optional) 
     * @return Success
     */
    startCloneTrainingSet(sourceTrainingSetId: string, newTrainingSetName: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/training-sets/{sourceTrainingSetId}/startclone?";
        if (sourceTrainingSetId === undefined || sourceTrainingSetId === null)
            throw new Error("The parameter 'sourceTrainingSetId' must be defined.");
        url_ = url_.replace("{sourceTrainingSetId}", encodeURIComponent("" + sourceTrainingSetId));
        if (newTrainingSetName !== undefined && newTrainingSetName !== null)
            url_ += "newTrainingSetName=" + encodeURIComponent("" + newTrainingSetName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartCloneTrainingSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartCloneTrainingSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartCloneTrainingSet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCloneResult(executionName: string): Observable<StringStateMachineExecutionResult> {
        let url_ = this.baseUrl + "/api/training-sets/getCloneResult/{executionName}";
        if (executionName === undefined || executionName === null)
            throw new Error("The parameter 'executionName' must be defined.");
        url_ = url_.replace("{executionName}", encodeURIComponent("" + executionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloneResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloneResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringStateMachineExecutionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringStateMachineExecutionResult>;
        }));
    }

    protected processGetCloneResult(response: HttpResponseBase): Observable<StringStateMachineExecutionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringStateMachineExecutionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UploadICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_IMAGE_CLASSIFICATION_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-image-classification";
    }

    /**
     * @param filename (optional) 
     * @return Success
     */
    getSignedUrl(filename: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/upload?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignedUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignedUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSignedUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VersionICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_IMAGE_CLASSIFICATION_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-image-classification";
    }

    /**
     * Get version info
     * @return Success
     */
    getVersionInfo(): Observable<string> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetVersionInfo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    myTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/version/myversion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMyTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMyTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMyTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Bottle caps. The name should be unique */
export class BottleCap implements IBottleCap {
    /** Gets/sets the id of the bottle cap */
    id?: string | null;
    /** The brand */
    brand?: string | null;
    /** The brand label from insights */
    insightsBrandLabel?: string | null;
    /** The description of the bottle cap */
    description?: string | null;
    /** The manufacturer */
    manufacturer?: string | null;
    /** The country of origin */
    country?: string | null;
    /** Image url with the cap */
    imageUrl?: string | null;
    /** The treshold used when classify (if percentage is lower than threshold label will be set to 'Other') */
    threshold?: number | null;
    /** Bottle Product Id */
    bottleProductId?: string | null;

    constructor(data?: IBottleCap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.insightsBrandLabel = _data["insightsBrandLabel"] !== undefined ? _data["insightsBrandLabel"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.manufacturer = _data["manufacturer"] !== undefined ? _data["manufacturer"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.threshold = _data["threshold"] !== undefined ? _data["threshold"] : <any>null;
            this.bottleProductId = _data["bottleProductId"] !== undefined ? _data["bottleProductId"] : <any>null;
        }
    }

    static fromJS(data: any): BottleCap {
        data = typeof data === 'object' ? data : {};
        let result = new BottleCap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["insightsBrandLabel"] = this.insightsBrandLabel !== undefined ? this.insightsBrandLabel : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["threshold"] = this.threshold !== undefined ? this.threshold : <any>null;
        data["bottleProductId"] = this.bottleProductId !== undefined ? this.bottleProductId : <any>null;
        return data;
    }
}

/** Bottle caps. The name should be unique */
export interface IBottleCap {
    /** Gets/sets the id of the bottle cap */
    id?: string | null;
    /** The brand */
    brand?: string | null;
    /** The brand label from insights */
    insightsBrandLabel?: string | null;
    /** The description of the bottle cap */
    description?: string | null;
    /** The manufacturer */
    manufacturer?: string | null;
    /** The country of origin */
    country?: string | null;
    /** Image url with the cap */
    imageUrl?: string | null;
    /** The treshold used when classify (if percentage is lower than threshold label will be set to 'Other') */
    threshold?: number | null;
    /** Bottle Product Id */
    bottleProductId?: string | null;
}

/** Bottle caps. The name should be unique */
export class BottleCapPutRequest implements IBottleCapPutRequest {
    /** Bottle Product */
    bottleProductId?: string | null;
    /** The brand */
    brand?: string | null;
    /** The brand label from insights */
    insightsBrandLabel?: string | null;
    /** The description of the bottle cap */
    description?: string | null;
    /** The manufacturer */
    manufacturer?: string | null;
    /** The country of origin */
    country?: string | null;
    /** Gets/Sets the state */
    state?: string | null;
    /** Gets/sets the type */
    type?: string | null;
    /** Gets/sets the image url */
    imageUrl?: string | null;
    /** Gets/sets the treshold */
    threshold?: number | null;

    constructor(data?: IBottleCapPutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bottleProductId = _data["bottleProductId"] !== undefined ? _data["bottleProductId"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.insightsBrandLabel = _data["insightsBrandLabel"] !== undefined ? _data["insightsBrandLabel"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.manufacturer = _data["manufacturer"] !== undefined ? _data["manufacturer"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.threshold = _data["threshold"] !== undefined ? _data["threshold"] : <any>null;
        }
    }

    static fromJS(data: any): BottleCapPutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BottleCapPutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bottleProductId"] = this.bottleProductId !== undefined ? this.bottleProductId : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["insightsBrandLabel"] = this.insightsBrandLabel !== undefined ? this.insightsBrandLabel : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["threshold"] = this.threshold !== undefined ? this.threshold : <any>null;
        return data;
    }
}

/** Bottle caps. The name should be unique */
export interface IBottleCapPutRequest {
    /** Bottle Product */
    bottleProductId?: string | null;
    /** The brand */
    brand?: string | null;
    /** The brand label from insights */
    insightsBrandLabel?: string | null;
    /** The description of the bottle cap */
    description?: string | null;
    /** The manufacturer */
    manufacturer?: string | null;
    /** The country of origin */
    country?: string | null;
    /** Gets/Sets the state */
    state?: string | null;
    /** Gets/sets the type */
    type?: string | null;
    /** Gets/sets the image url */
    imageUrl?: string | null;
    /** Gets/sets the treshold */
    threshold?: number | null;
}

export class BottleProduct implements IBottleProduct {
    id?: string | null;
    name?: string | null;
    imageUrl?: string | null;
    description?: string | null;
    bottleCapIds?: string[] | null;

    constructor(data?: IBottleProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            if (Array.isArray(_data["bottleCapIds"])) {
                this.bottleCapIds = [] as any;
                for (let item of _data["bottleCapIds"])
                    this.bottleCapIds!.push(item);
            }
            else {
                this.bottleCapIds = <any>null;
            }
        }
    }

    static fromJS(data: any): BottleProduct {
        data = typeof data === 'object' ? data : {};
        let result = new BottleProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.bottleCapIds)) {
            data["bottleCapIds"] = [];
            for (let item of this.bottleCapIds)
                data["bottleCapIds"].push(item);
        }
        return data;
    }
}

export interface IBottleProduct {
    id?: string | null;
    name?: string | null;
    imageUrl?: string | null;
    description?: string | null;
    bottleCapIds?: string[] | null;
}

export class ClassifierModel implements IClassifierModel {
    id!: string;
    name!: string;
    trainingSetId!: string;
    classifierType!: string;
    bottleCaps!: string[];
    trainingDetails?: TrainingDetails | null;
    references!: RefId[];
    instanceType?: string | null;

    constructor(data?: IClassifierModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.bottleCaps = [];
            this.references = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.trainingSetId = _data["trainingSetId"] !== undefined ? _data["trainingSetId"] : <any>null;
            this.classifierType = _data["classifierType"] !== undefined ? _data["classifierType"] : <any>null;
            if (Array.isArray(_data["bottleCaps"])) {
                this.bottleCaps = [] as any;
                for (let item of _data["bottleCaps"])
                    this.bottleCaps!.push(item);
            }
            else {
                this.bottleCaps = <any>null;
            }
            this.trainingDetails = _data["trainingDetails"] ? TrainingDetails.fromJS(_data["trainingDetails"]) : <any>null;
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(RefId.fromJS(item));
            }
            else {
                this.references = <any>null;
            }
            this.instanceType = _data["instanceType"] !== undefined ? _data["instanceType"] : <any>null;
        }
    }

    static fromJS(data: any): ClassifierModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClassifierModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["trainingSetId"] = this.trainingSetId !== undefined ? this.trainingSetId : <any>null;
        data["classifierType"] = this.classifierType !== undefined ? this.classifierType : <any>null;
        if (Array.isArray(this.bottleCaps)) {
            data["bottleCaps"] = [];
            for (let item of this.bottleCaps)
                data["bottleCaps"].push(item);
        }
        data["trainingDetails"] = this.trainingDetails ? this.trainingDetails.toJSON() : <any>null;
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        data["instanceType"] = this.instanceType !== undefined ? this.instanceType : <any>null;
        return data;
    }
}

export interface IClassifierModel {
    id: string;
    name: string;
    trainingSetId: string;
    classifierType: string;
    bottleCaps: string[];
    trainingDetails?: TrainingDetails | null;
    references: RefId[];
    instanceType?: string | null;
}

export class ClassifierModelStateMachineExecutionResult implements IClassifierModelStateMachineExecutionResult {
    result?: ClassifierModel | null;
    status!: StateMachineExecutionStatus;
    failedReason?: string | null;

    constructor(data?: IClassifierModelStateMachineExecutionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ClassifierModel.fromJS(_data["result"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.failedReason = _data["failedReason"] !== undefined ? _data["failedReason"] : <any>null;
        }
    }

    static fromJS(data: any): ClassifierModelStateMachineExecutionResult {
        data = typeof data === 'object' ? data : {};
        let result = new ClassifierModelStateMachineExecutionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["failedReason"] = this.failedReason !== undefined ? this.failedReason : <any>null;
        return data;
    }
}

export interface IClassifierModelStateMachineExecutionResult {
    result?: ClassifierModel | null;
    status: StateMachineExecutionStatus;
    failedReason?: string | null;
}

export class ClassifierModelStatus implements IClassifierModelStatus {
    trainingJobStatus!: TrainingStatus;
    trainingJobDescription?: string | null;
    deployStatus!: DeployStatus;
    deployStatusDescription?: string | null;
    customTrainingInfo?: any | null;
    customDeployInfo?: any | null;

    constructor(data?: IClassifierModelStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingJobStatus = _data["trainingJobStatus"] !== undefined ? _data["trainingJobStatus"] : <any>null;
            this.trainingJobDescription = _data["trainingJobDescription"] !== undefined ? _data["trainingJobDescription"] : <any>null;
            this.deployStatus = _data["deployStatus"] !== undefined ? _data["deployStatus"] : <any>null;
            this.deployStatusDescription = _data["deployStatusDescription"] !== undefined ? _data["deployStatusDescription"] : <any>null;
            this.customTrainingInfo = _data["customTrainingInfo"] !== undefined ? _data["customTrainingInfo"] : <any>null;
            this.customDeployInfo = _data["customDeployInfo"] !== undefined ? _data["customDeployInfo"] : <any>null;
        }
    }

    static fromJS(data: any): ClassifierModelStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ClassifierModelStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingJobStatus"] = this.trainingJobStatus !== undefined ? this.trainingJobStatus : <any>null;
        data["trainingJobDescription"] = this.trainingJobDescription !== undefined ? this.trainingJobDescription : <any>null;
        data["deployStatus"] = this.deployStatus !== undefined ? this.deployStatus : <any>null;
        data["deployStatusDescription"] = this.deployStatusDescription !== undefined ? this.deployStatusDescription : <any>null;
        data["customTrainingInfo"] = this.customTrainingInfo !== undefined ? this.customTrainingInfo : <any>null;
        data["customDeployInfo"] = this.customDeployInfo !== undefined ? this.customDeployInfo : <any>null;
        return data;
    }
}

export interface IClassifierModelStatus {
    trainingJobStatus: TrainingStatus;
    trainingJobDescription?: string | null;
    deployStatus: DeployStatus;
    deployStatusDescription?: string | null;
    customTrainingInfo?: any | null;
    customDeployInfo?: any | null;
}

export class ClassifierModelWithDetails implements IClassifierModelWithDetails {
    model!: ClassifierModel;
    status!: ClassifierModelStatus;

    constructor(data?: IClassifierModelWithDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = new ClassifierModel();
            this.status = new ClassifierModelStatus();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? ClassifierModel.fromJS(_data["model"]) : new ClassifierModel();
            this.status = _data["status"] ? ClassifierModelStatus.fromJS(_data["status"]) : new ClassifierModelStatus();
        }
    }

    static fromJS(data: any): ClassifierModelWithDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ClassifierModelWithDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>null;
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        return data;
    }
}

export interface IClassifierModelWithDetails {
    model: ClassifierModel;
    status: ClassifierModelStatus;
}

export enum DeployStatus {
    ReadyToDeploy = "ReadyToDeploy",
    Pending = "Pending",
    Success = "Success",
    Error = "Error",
    Other = "Other",
}

export class FileToUpload implements IFileToUpload {
    fileName?: string | null;
    fileSize?: number | null;
    fileType?: string | null;
    fileAsBase64?: string | null;
    readonly fileAsByteArray?: string | null;

    constructor(data?: IFileToUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : <any>null;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : <any>null;
            this.fileAsBase64 = _data["fileAsBase64"] !== undefined ? _data["fileAsBase64"] : <any>null;
            (<any>this).fileAsByteArray = _data["fileAsByteArray"] !== undefined ? _data["fileAsByteArray"] : <any>null;
        }
    }

    static fromJS(data: any): FileToUpload {
        data = typeof data === 'object' ? data : {};
        let result = new FileToUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : <any>null;
        data["fileType"] = this.fileType !== undefined ? this.fileType : <any>null;
        data["fileAsBase64"] = this.fileAsBase64 !== undefined ? this.fileAsBase64 : <any>null;
        data["fileAsByteArray"] = this.fileAsByteArray !== undefined ? this.fileAsByteArray : <any>null;
        return data;
    }
}

export interface IFileToUpload {
    fileName?: string | null;
    fileSize?: number | null;
    fileType?: string | null;
    fileAsBase64?: string | null;
    fileAsByteArray?: string | null;
}

/** An image set represents a grouping of images of a specific bottle cap for a specific training set id. */
export class ImageSet implements IImageSet {
    /** The training set id */
    trainingSetId?: string | null;
    /** The bottle cap id of this image set */
    bottleCapId?: string | null;
    /** The list of image URLs */
    imageUrls?: string[] | null;

    constructor(data?: IImageSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingSetId = _data["trainingSetId"] !== undefined ? _data["trainingSetId"] : <any>null;
            this.bottleCapId = _data["bottleCapId"] !== undefined ? _data["bottleCapId"] : <any>null;
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls!.push(item);
            }
            else {
                this.imageUrls = <any>null;
            }
        }
    }

    static fromJS(data: any): ImageSet {
        data = typeof data === 'object' ? data : {};
        let result = new ImageSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingSetId"] = this.trainingSetId !== undefined ? this.trainingSetId : <any>null;
        data["bottleCapId"] = this.bottleCapId !== undefined ? this.bottleCapId : <any>null;
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        return data;
    }
}

/** An image set represents a grouping of images of a specific bottle cap for a specific training set id. */
export interface IImageSet {
    /** The training set id */
    trainingSetId?: string | null;
    /** The bottle cap id of this image set */
    bottleCapId?: string | null;
    /** The list of image URLs */
    imageUrls?: string[] | null;
}

/** An image represents is represented by an URL and an Id */
export class ImageUrl implements IImageUrl {
    url?: string | null;

    constructor(data?: IImageUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): ImageUrl {
        data = typeof data === 'object' ? data : {};
        let result = new ImageUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

/** An image represents is represented by an URL and an Id */
export interface IImageUrl {
    url?: string | null;
}

export class PredictionRequest implements IPredictionRequest {
    modelId?: string | null;
    imageUrl?: string | null;

    constructor(data?: IPredictionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"] !== undefined ? _data["modelId"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): PredictionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PredictionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId !== undefined ? this.modelId : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        return data;
    }
}

export interface IPredictionRequest {
    modelId?: string | null;
    imageUrl?: string | null;
}

export class PredictionResponse implements IPredictionResponse {
    /** Top 5 probabilities */
    probabilities?: { [key: string]: number; } | null;
    /** The bottle cap with the max probability */
    maxProbabilityBottleCapId!: string;
    /** The max probability */
    maxProbabilityValue!: number;
    bottleCap!: BottleCap;
    bottleProduct?: BottleProduct | null;
    /** The score given by focus/sharpness. Using some kind of Laplacian and standard deviation algo */
    focusScore!: number;
    /** Focus Score adjusted to be between 0 and 1 (as percentage)
0 means extremely blurry 
1 means very sharp */
    focusScorePercent!: number;
    /** if FocusScore < FocusTreshold this field will be true */
    isBlurry!: boolean;

    constructor(data?: IPredictionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.bottleCap = new BottleCap();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["probabilities"]) {
                this.probabilities = {} as any;
                for (let key in _data["probabilities"]) {
                    if (_data["probabilities"].hasOwnProperty(key))
                        (<any>this.probabilities)![key] = _data["probabilities"][key] !== undefined ? _data["probabilities"][key] : <any>null;
                }
            }
            else {
                this.probabilities = <any>null;
            }
            this.maxProbabilityBottleCapId = _data["maxProbabilityBottleCapId"] !== undefined ? _data["maxProbabilityBottleCapId"] : <any>null;
            this.maxProbabilityValue = _data["maxProbabilityValue"] !== undefined ? _data["maxProbabilityValue"] : <any>null;
            this.bottleCap = _data["bottleCap"] ? BottleCap.fromJS(_data["bottleCap"]) : new BottleCap();
            this.bottleProduct = _data["bottleProduct"] ? BottleProduct.fromJS(_data["bottleProduct"]) : <any>null;
            this.focusScore = _data["focusScore"] !== undefined ? _data["focusScore"] : <any>null;
            this.focusScorePercent = _data["focusScorePercent"] !== undefined ? _data["focusScorePercent"] : <any>null;
            this.isBlurry = _data["isBlurry"] !== undefined ? _data["isBlurry"] : <any>null;
        }
    }

    static fromJS(data: any): PredictionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PredictionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.probabilities) {
            data["probabilities"] = {};
            for (let key in this.probabilities) {
                if (this.probabilities.hasOwnProperty(key))
                    (<any>data["probabilities"])[key] = this.probabilities[key] !== undefined ? this.probabilities[key] : <any>null;
            }
        }
        data["maxProbabilityBottleCapId"] = this.maxProbabilityBottleCapId !== undefined ? this.maxProbabilityBottleCapId : <any>null;
        data["maxProbabilityValue"] = this.maxProbabilityValue !== undefined ? this.maxProbabilityValue : <any>null;
        data["bottleCap"] = this.bottleCap ? this.bottleCap.toJSON() : <any>null;
        data["bottleProduct"] = this.bottleProduct ? this.bottleProduct.toJSON() : <any>null;
        data["focusScore"] = this.focusScore !== undefined ? this.focusScore : <any>null;
        data["focusScorePercent"] = this.focusScorePercent !== undefined ? this.focusScorePercent : <any>null;
        data["isBlurry"] = this.isBlurry !== undefined ? this.isBlurry : <any>null;
        return data;
    }
}

export interface IPredictionResponse {
    /** Top 5 probabilities */
    probabilities?: { [key: string]: number; } | null;
    /** The bottle cap with the max probability */
    maxProbabilityBottleCapId: string;
    /** The max probability */
    maxProbabilityValue: number;
    bottleCap: BottleCap;
    bottleProduct?: BottleProduct | null;
    /** The score given by focus/sharpness. Using some kind of Laplacian and standard deviation algo */
    focusScore: number;
    /** Focus Score adjusted to be between 0 and 1 (as percentage)
0 means extremely blurry 
1 means very sharp */
    focusScorePercent: number;
    /** if FocusScore < FocusTreshold this field will be true */
    isBlurry: boolean;
}

export class RefId implements IRefId {
    id?: string | null;
    name?: string | null;

    constructor(data?: IRefId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): RefId {
        data = typeof data === 'object' ? data : {};
        let result = new RefId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IRefId {
    id?: string | null;
    name?: string | null;
}

export enum StateMachineExecutionStatus {
    Running = "Running",
    Error = "Error",
    Completed = "Completed",
}

export class StringStateMachineExecutionResult implements IStringStateMachineExecutionResult {
    result?: string | null;
    status!: StateMachineExecutionStatus;
    failedReason?: string | null;

    constructor(data?: IStringStateMachineExecutionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.failedReason = _data["failedReason"] !== undefined ? _data["failedReason"] : <any>null;
        }
    }

    static fromJS(data: any): StringStateMachineExecutionResult {
        data = typeof data === 'object' ? data : {};
        let result = new StringStateMachineExecutionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["failedReason"] = this.failedReason !== undefined ? this.failedReason : <any>null;
        return data;
    }
}

export interface IStringStateMachineExecutionResult {
    result?: string | null;
    status: StateMachineExecutionStatus;
    failedReason?: string | null;
}

export class TrainingDetails implements ITrainingDetails {
    classifierType?: string | null;
    layerCount?: number | null;
    epochCount?: number | null;
    learningRate?: number | null;
    batchSize?: number | null;
    imageFormat?: string | null;
    validationSetId?: string | null;
    sageMakerInstanceType?: string | null;

    constructor(data?: ITrainingDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classifierType = _data["classifierType"] !== undefined ? _data["classifierType"] : <any>null;
            this.layerCount = _data["layerCount"] !== undefined ? _data["layerCount"] : <any>null;
            this.epochCount = _data["epochCount"] !== undefined ? _data["epochCount"] : <any>null;
            this.learningRate = _data["learningRate"] !== undefined ? _data["learningRate"] : <any>null;
            this.batchSize = _data["batchSize"] !== undefined ? _data["batchSize"] : <any>null;
            this.imageFormat = _data["imageFormat"] !== undefined ? _data["imageFormat"] : <any>null;
            this.validationSetId = _data["validationSetId"] !== undefined ? _data["validationSetId"] : <any>null;
            this.sageMakerInstanceType = _data["sageMakerInstanceType"] !== undefined ? _data["sageMakerInstanceType"] : <any>null;
        }
    }

    static fromJS(data: any): TrainingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classifierType"] = this.classifierType !== undefined ? this.classifierType : <any>null;
        data["layerCount"] = this.layerCount !== undefined ? this.layerCount : <any>null;
        data["epochCount"] = this.epochCount !== undefined ? this.epochCount : <any>null;
        data["learningRate"] = this.learningRate !== undefined ? this.learningRate : <any>null;
        data["batchSize"] = this.batchSize !== undefined ? this.batchSize : <any>null;
        data["imageFormat"] = this.imageFormat !== undefined ? this.imageFormat : <any>null;
        data["validationSetId"] = this.validationSetId !== undefined ? this.validationSetId : <any>null;
        data["sageMakerInstanceType"] = this.sageMakerInstanceType !== undefined ? this.sageMakerInstanceType : <any>null;
        return data;
    }
}

export interface ITrainingDetails {
    classifierType?: string | null;
    layerCount?: number | null;
    epochCount?: number | null;
    learningRate?: number | null;
    batchSize?: number | null;
    imageFormat?: string | null;
    validationSetId?: string | null;
    sageMakerInstanceType?: string | null;
}

/** A training set groups together several image sets */
export class TrainingSet implements ITrainingSet {
    readonly id?: string | null;
    name!: string;
    description?: string | null;
    dateCreated?: Date | null;
    /** The list of bottle caps IDs in this training set */
    bottleCaps?: string[] | null;
    /** The count per each bottle cap */
    bottleCapsCount?: { [key: string]: number; } | null;

    constructor(data?: ITrainingSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>null;
            if (Array.isArray(_data["bottleCaps"])) {
                this.bottleCaps = [] as any;
                for (let item of _data["bottleCaps"])
                    this.bottleCaps!.push(item);
            }
            else {
                this.bottleCaps = <any>null;
            }
            if (_data["bottleCapsCount"]) {
                this.bottleCapsCount = {} as any;
                for (let key in _data["bottleCapsCount"]) {
                    if (_data["bottleCapsCount"].hasOwnProperty(key))
                        (<any>this.bottleCapsCount)![key] = _data["bottleCapsCount"][key] !== undefined ? _data["bottleCapsCount"][key] : <any>null;
                }
            }
            else {
                this.bottleCapsCount = <any>null;
            }
        }
    }

    static fromJS(data: any): TrainingSet {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>null;
        if (Array.isArray(this.bottleCaps)) {
            data["bottleCaps"] = [];
            for (let item of this.bottleCaps)
                data["bottleCaps"].push(item);
        }
        if (this.bottleCapsCount) {
            data["bottleCapsCount"] = {};
            for (let key in this.bottleCapsCount) {
                if (this.bottleCapsCount.hasOwnProperty(key))
                    (<any>data["bottleCapsCount"])[key] = this.bottleCapsCount[key] !== undefined ? this.bottleCapsCount[key] : <any>null;
            }
        }
        return data;
    }
}

/** A training set groups together several image sets */
export interface ITrainingSet {
    id?: string | null;
    name: string;
    description?: string | null;
    dateCreated?: Date | null;
    /** The list of bottle caps IDs in this training set */
    bottleCaps?: string[] | null;
    /** The count per each bottle cap */
    bottleCapsCount?: { [key: string]: number; } | null;
}

export enum TrainingStatus {
    ReadyToTrain = "ReadyToTrain",
    Pending = "Pending",
    Success = "Success",
    Error = "Error",
    Other = "Other",
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}